// extracted by mini-css-extract-plugin
export default {"contents":"fG-z","sectionHeading":"gG-z"};